module.exports = __webpack_public_path__ + "img/logo_similes.15116c35.png";